<template>
  <div class="tabulation">
    <el-card class="chart-card">
      <!-- 搜索框 -->
      <div class="grabble">
        <div style="width: 70%;display: flex;align-items: center;">
          <el-input
            class="hunt"
            v-model="input"
            placeholder="请输姓名"
            size="large"
            @input="orangutan"
			clearable 
          />
          <el-input
            class="hunt"
            v-model="encoding"
            placeholder="请输入会员编码"
            size="large"
            @input="orangutan"
			clearable 
          />
          <el-select
            class="hunt"
            v-model="ability"
            placeholder="请选择组织名称"
            size="large"
            @click="multiple"
            clearable
            @change="numerical"
          />
          <!-- 是否达标 -->
            <el-select v-model="achieve" @change="fulfill" class="hunt" placeholder="请选择是否达标" clearable @clear="empty" size="large">
              <el-option label="是" value="1"  style="width:100%; text-align-last: center;" ></el-option>
              <el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
            </el-select>
          <el-button style="margin-left: 10px" type="primary" size="large" @click="search1" :loading='formative'
            ><el-icon class="cancelgu"> <Search /> </el-icon>搜索</el-button
          >
        </div>
      </div>
      <div class="summation">
        <div class="hint">统计 : {{totality}}人</div>
      </div>
		<div class="feature-btn">
			<el-button
				style="margin-left: 10px"
				type="primary"
				size="default"
				@click="derive"
				:loading="ConfirmLoading"
				:disabled='jinyong'
				><img src="../../assets/daochu.png" style="width:14px;margin-right: 6px" alt="">导出</el-button
			>
			<el-button
				style="margin-left: 10px"
				type="primary"
				size="default"
				@click="append"
				><img src="../../assets/fenxi.png" style="width:19px;margin-right: 6px" alt=""> 数据分析</el-button
			>
		</div>
      <el-table
		ref="tableRef"
        :data="filterTableData"
        style="width: 100%"
        row-key="unionId"
        border
		scrollbar-always-on
        :header-cell-style="{ background: '#F5F7FA' }"
        :empty-text="texts"
		v-loading="tableLoading"
      >
        <!-- 姓名 -->
        <el-table-column
          label="姓名"
          prop="name"
          align="center"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 会员编码 -->
        <el-table-column align="center" label="会员编码" :show-overflow-tooltip='true' prop="username" />
        <!-- 所属工会 -->
        <el-table-column
          label="所属工会"
          prop="unionName"
          align="center"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 所属部门 -->
        <el-table-column
          label="所属部门"
          prop="departmentName"
          align="center"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 答题时间 -->
        <el-table-column
          label="答题时间"
          prop="createTime"
          align="center"
          :formatter="tiems"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 答题数量 -->
        <el-table-column
          label="答题数量"
          prop="answersNumber"
          align="center"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 是否达标 -->
        <el-table-column
          label="是否达标"
          prop="isStandard"
          align="center"
          :formatter="formatSex"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!-- 达标时间 -->
        <el-table-column
          label="达标时间"
          prop="standardTime"
          align="center"
          :formatter="standard"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="190">
          <template #default="scope">
			<el-button type="primary" link @click="examine(scope.row.userId)"><el-icon class="cancel"><Search /></el-icon>查看</el-button>
            <!-- <el-button size="default" @click="expurgate(scope.row.characterId)" class="red"
              ><el-icon class="cancel"> <Delete /> </el-icon>删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格分页 -->
      <!-- 一页时候隐藏 hide-on-single-page="true" -->
      <el-pagination
		:hide-on-single-page="true"
        layout="prev, pager, next,sizes"
		v-model:currentPage="currentPage"
        :page-sizes="[6, 12, 18, 24]" 
        :page-size="pagesize"
		:total="paginationTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!-- 删除按钮弹窗 -->
    <el-dialog v-model="remove" title="删除" width="30%" center>
      <div class="labor">
        <div class="sure">确定删除吗？</div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="affirm">确定</el-button>
          <el-button @click="remove=false">取消</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 所属组织弹窗 -->
    <div>
      <el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="true" destroy-on-close>
        <el-tree
          :data="texture"
          :props="defaultProps"
          accordion
          @node-click="dendrogram"
        />
      <template #footer><el-button type="primary" @click="yes">确定</el-button></template></el-dialog>
    </div>
    <!-- 导出提示 -->
    <div>
      <s3-layer v-model="anew" title="提示" :shadeClose="true" :area="['50px', '170px']" @yes="yes">
        <div class="task">
          {{quoth}}
        </div>
      </s3-layer>
    </div>
  </div>
</template>
<script>
import { Search} from "@element-plus/icons-vue";
import { useRouter,useRoute} from "vue-router";
import{ ref,onMounted,onActivated,nextTick} from 'vue'
import { DTtotal,Zzlist,XJremove,DTderive } from '../../utils/api'
import moments from 'moment'
import qs from 'qs'
import { ElMessage } from "element-plus";
export default {
  name:"statistics",
  setup() {
    // 导出提示弹窗
    let quoth=ref('')
    let anew=ref(false)
	//获取列表页传来的id
	const route = useRoute()
	let loading = ref(true)
    // 搜索加载
    let formative=ref(false)
	const tableLoading = ref(true)
	const tableRef = ref(null)
	const refreshTableLayout = () => {
	  nextTick(() => tableRef.value?.doLayout?.())
	}
    // 导出加载
    let ConfirmLoading=ref(false)
    // 导出是否禁用
    let jinyong=ref(false)
    // 导出按钮
    let derive=()=>{
      ConfirmLoading.value=true
      jinyong.value=true
      // console.log('id',sessionStorage.getItem('summation'))
      // console.log('姓名',input.value)
      // console.log('组织code',Hcode.value)
      // console.log('会员编码',encoding.value)
      // console.log('是否达标',achieve.value)
      let data={
        id:sessionStorage.getItem('summation'),
        name:input.value,
        username:encoding.value,
        unionCode:Hcode.value,
        isStandard:achieve.value
      }
      DTderive(qs.stringify(data)).then((res)=>{
        console.log(res)
        if(res.data.code==0){
          anew.value=true
          quoth.value='任务已提交，请在右侧查看进度'
          jinyong.value=false
          ConfirmLoading.value=false
          // window.open(res.data.data.excelUrl)
        }else{
          jinyong.value=false
          ConfirmLoading.value=false
          ElMessage({
            message: res.data.msg,
            type: "error",
            center: true,
          });
        }
      })
    }
	let translate = ref(2)
	onActivated(() => {
		translate.value = route.params.UserId
		if (translate.value == 1) {
			loading.value = true
			list()
		}
	})
    // 是否达标
    let achieve=ref('')
    let standard= (row, column, cellValue) => {
      if (cellValue == 0) {
        return "-";
      } else if (cellValue !==0) {
        return moments(cellValue*1000).format().substring(0,10)
      }
    };
    // 判断类型
    let formatSex = (row, column, cellValue) => {
      if (cellValue == 1) {
        return "是";
      } else if (cellValue === 2) {
        return "否";
      }
    };
    // 查看跳转
    let examine=(id)=>{
      router.push('/substance')
      sessionStorage.setItem('DTuserid', id)

      console.log(id)
    }
    // 会员编码
    let encoding=ref('')
    // 删除确定
    let affirm=()=>{
      let data={
        characterId:modeid.value
      }
      XJremove(qs.stringify(data)).then((res)=>{
        console.log(res)
        ElMessage({
          message: '删除成功',
          type: "success",
          center: true,
        });
        remove.value=false
        list()
      })
    }
    // 删除弹窗
    let remove=ref(false)
    // 获取信息id
    let modeid=ref('')
    // 删除按钮
    let expurgate=(id)=>{
      remove.value=true
      modeid.value=id
      console.log(id)
    }
    // 会员姓名输入框改变
    // const orangutan=()=>{
    //   if(input.value==''&&ability.value==''&&encoding.value==''){
    //     list()
    //   }
    // }
    // 选择组织名称变化
    let numerical=()=>{
      // if(input.value==''&&ability.value==''&&encoding.value==''){
      //   list()
      // }
      Hcode.value=''
    }
    // 搜索按钮
    let search1=()=>{
      formative.value=true
	  currentPage.value=1
      search()
    }
    let search=()=>{
	  tableLoading.value=true
	  totality.value=0
      let data={
        limit:branches.value,
        page:currentPage.value,
        id:sessionStorage.getItem('summation'),
        name:input.value,
        username:encoding.value,
        unionCode:Hcode.value,
        isStandard:achieve.value
      }
      DTtotal(qs.stringify(data)).then((res)=>{
        // 列表总数
        totality.value=res.data.data.page.totalCount
		paginationTotal.value=res.data.data.page.totalCount
        // 列表数据
        filterTableData.value=res.data.data.page.list
		texts.value=filterTableData.value.length ? '' : '暂无数据'
	  }).catch(() => {
		ElMessage({ message: '获取答题统计列表失败', type: 'error', center: true })
	  }).finally(() => {
		formative.value=false
		tableLoading.value=false
		refreshTableLayout()
	  })
    }
    // 标题内容
    let input=ref('')
    // 搜索框弹窗
    // 获取code
    let Hcode=ref('')
    // 获取选项
    let ability=ref('')
    let dendrogram = (node)=>{
      ability.value=node.unionName
      Hcode.value=node.unionCode
      console.log(node)
    }
    let visible=ref(false)
    let multiple=()=>{
      visible.value=true
    }
    // 搜索框
    let texture=ref([])
    const defaultProps = {
      children: 'unionDtoList',
      label: 'unionName',
    }
    // 获取所有组织列表
    let own=()=>{
      Zzlist().then((res)=>{
        console.log(res)
        if(res.data.code==0){
          texture.value=res.data.data.wholeUnionList
        }
      })
    }
    // 加载中 暂无数据列表
    let texts=ref('加载中')
    onMounted(()=>{
      list()
      // 所有组织列表接口
      own()
    })
     // 时间转换
    let tiems=(row, colum,cellValue )=>{
    if(typeof cellValue=='number'){
      return moments(cellValue*1000).format().substring(0,10)
    }
    }
    // 分页处理
    let currentPage=ref(1)
    let pagesize=ref(6)
    let handleSizeChange=(size)=>{
	  currentPage.value=1
      pagesize.value=size
      branches.value=size
      if(input.value!==''||ability.value!==''||encoding.value!==''||achieve.value!==''){
        search()
      }else{
        list()
      }
    }
    let handleCurrentChange=(size)=>{
      currentPage.value=size
      if(input.value!==''||ability.value!==''||encoding.value!==''||achieve.value!==''){
        search()
      }else{
        list()
      }
    }
    // 数据增加
    let branches=ref(6)
    // 数据总数
	let totality =ref(0)
	let paginationTotal = ref(0)
    // 获取人物列表
    let list =()=>{
	  tableLoading.value=true
	  totality.value=0
      let data={
        limit:branches.value,
        page:currentPage.value,
        id:sessionStorage.getItem('summation')
      }
	  DTtotal(qs.stringify(data)).then((res)=>{
        if(res.data.code==0){
          // 列表总数
          totality.value=res.data.data.page.totalCount
		  paginationTotal.value=res.data.data.page.totalCount
          // 列表数据
          filterTableData.value=res.data.data.page.list
		  texts.value=filterTableData.value.length ? '' : '暂无数据'
        }
	  }).catch(() => {
		ElMessage({ message: '获取答题统计列表失败', type: 'error', center: true })
	  }).finally(() => {
		tableLoading.value=false
		refreshTableLayout()
	  })
    }
    // 编辑跳转
    const copyreader = (id)=>{
      console.log(id)
      sessionStorage.setItem('chara', id)
      router.push('/dxgledit')
    }
    // 路由跳转
    const router = useRouter()
    // 头部添加跳转
    let append=()=>{
      router.push('/consequence')
    }
    // 列表数据循环
    const filterTableData = ref([])
    return {
      quoth,
      anew,
      jinyong,
      // 搜索加载
      search1,
      formative,
	  tableLoading,
	  tableRef,
      ConfirmLoading,
      derive,
      achieve,
      standard,
      formatSex,
      // 查看跳转
      examine,
      encoding,
      affirm,
      // 删除弹窗
      remove,
      // 删除按钮
      expurgate,
      numerical,
      // orangutan,
      // 标题内容
      input,
      // 搜索按钮
      search,
      // 搜索框
      ability,
      dendrogram,
      visible,
      multiple,
      defaultProps,
      texture,
      // 分页处理
      handleCurrentChange,
      handleSizeChange,
      currentPage,
      pagesize,
      // 加载中 暂无数据
      texts,
      tiems,
      // 列表总数
      totality,
	  paginationTotal,
      // 编辑跳转
      copyreader,
      // 头部组织添加跳转
      append,
      // 循环列表数据
      filterTableData
    };
  },
  components: {
    Search,
  },
};
</script>
<style lang="scss" scoped>
.summation{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.feature-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 15px 0;
}
::v-deep .chart-card::-webkit-scrollbar{
  display:none
}
.chart-card{
  height: calc(100vh - 150px);
  overflow: auto;
}
.hint{
  font-size: 14px;
  color: #909399;
  // font-weight: bold;
}
::v-deep  .el-table__empty-block{
  border-bottom: 1px solid #EBEEF5 !important;
}
::v-deep .el-table__body {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
::v-deep .el-table__header {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.hunt {
  width: 22%;
  margin-right: 10px;
}
.grabble {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}
.el-table__header {
  margin-top: 0;
  margin-bottom: 0;
}
.red {
  color: red;
  border: none;
  --el-button-bg-color: none;
  --el-button-hover-bg-color: none;
  --el-button-hover-text-color: none;
}
.red:hover {
  color: #fab6b6;
}
.bulur {
  color: #409eff;
  border: none;
  --el-button-bg-color: none;
  --el-button-hover-bg-color: none;
  --el-button-hover-text-color: none;
}
.bulur:hover {
  color: #a0cfff;
}
// .el-button{
//   border: none;
//   --el-button-bg-color:none;
//   --el-button-hover-bg-color:none;
//   --el-button-hover-text-color:none;
// }
.el-scrollbar__thumb {
  background-color: #ffffff;
}
.items {
  display: flex;
}
.el-select .el-input__inner {
  width: 183px;
}
::v-deep .el-dialog--center .el-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .el-select-dropdown__empty {
  display: none !important  ;
}
.el-select-dropdown__item {
  background-color: #ffffff;
  height: 40px !important;
}
.el-select-dropdown__item {
  overflow: visible;
}
.labor {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
::v-deep .el-input--small .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.tianjia {
  margin-left: 20px;
}
.cancel {
  margin-right: 5px;
  font-weight: 400;
}
.cancelgu {
  margin-right: 6px;
  font-weight: bold;
}
::v-deep .el-table__inner-wrapper::before {
  width: 0;
}
::v-deep .el-table .el-table__cell {
  padding-top: 15px;
  padding-bottom: 15px;
}
.el-card.is-always-shadow {
  width: 95%;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}
::v-deep .el-card__body {
  padding: 0;
}
.el-pagination {
  margin-top: 10px;
}
::v-deep .el-input--small .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.tabulation {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
::v-deep .el-scrollbar__thumb {
  display: none !important;
}
</style>
<style>
.el-popper {
  z-index: 10000 !important;
}
.modality {
  height: 150px !important;
}
/* .el-scrollbar__thumb {
  display: none !important;
} */
.el-select-dropdown__item.selected {
  font-weight: 500 !important;
}
</style>
